import { NextApiRequest } from 'next';
import { NextApiRequestQuery } from 'next/dist/server/api-utils';
import { GetPageConfigDataInterface, UrlInterface } from '../config';
import { getData } from 'utils/helpers/server/serverSideData';
import { DisciplineEnum } from 'types/types';
import { getDisciplineCookieFromRequest } from 'utils/helpers/server/cookies';

import { ConfigDataInterface } from 'submodules/api_middleware';

export const getUrlWithDiscipline = (
    req: NextApiRequest,
    query: NextApiRequestQuery,
    url: string,
    params?: string
): string => {
    const discipline = getDisciplineCookieFromRequest(
        req,
        query
    ) as DisciplineEnum;

    const base = '/';
    const disc = 'discipline=' + discipline;
    return base + url + '?' + disc + (params ? '&' + params : '');
};

export interface ConfigPageInterface<T> {
    config: T;
}

export const getPageConfigData = async <
    T extends ConfigDataInterface<string, string, string, string, string>
>(
    { req, res, api, query }: GetPageConfigDataInterface,
    url: UrlInterface
): Promise<T> => {
    const page = (url.url
        ? await getData(
              res,
              req,
              api
                  .config()
                  .get(getUrlWithDiscipline(req, query, url.url, url.params))
          )
        : null) || {
        modules: {},
        actions: {
            menu: {},
            other: {},
        },
    };
    if (!page.actions.other) page.actions.other = {};
    if (!page.actions.menu) page.actions.menu = {};

    const pageMenu =
        (url.menuUrl
            ? await getData(
                  res,
                  req,
                  api
                      .config()
                      .get(
                          getUrlWithDiscipline(
                              req,
                              query,
                              url.menuUrl,
                              url.params
                          )
                      )
              )
            : []) || [];

    const pageSubMenu =
        (url.subMenuUrl
            ? await getData(
                  res,
                  req,
                  api
                      .config()
                      .get(
                          getUrlWithDiscipline(
                              req,
                              query,
                              url.subMenuUrl,
                              url.params
                          )
                      )
              )
            : []) || [];

    //@ts-ignore-next-line
    return {
        page,
        pageMenu,
        pageSubMenu,
    };
};
